import { render } from "./videoBox.vue?vue&type=template&id=77d329e2&scoped=true"
import script from "./videoBox.vue?vue&type=script&lang=js"
export * from "./videoBox.vue?vue&type=script&lang=js"

import "./videoBox.vue?vue&type=style&index=0&id=77d329e2&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\isw-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d329e2"]])

export default __exports__